import {
  alpha,
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Paper,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Tabs,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
  TablePagination,
  IconButton,
  Dialog,
  Avatar,
  Menu,
  MenuItem,
  Button,
} from "@mui/material";
import { useTheme } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  a11yProps,
  dialogStyle,
  formatDate,
  formatServerValue,
  getComparator,
  getLastMessageFromObj,
  getNameFromPlatform,
  getRandomInt,
  globalCardStyle,
  isArrayWithValues,
  isObjWithValues,
  reduceLargeText,
  sortObjectByValues,
  stableSort,
  TabPanel,
  validateNumber,
} from "../../helper";
import {
  NoTasks,
  platformIcons,
  primaryLabel,
  secondaryLabel,
  sectionLabel,
  userTasksHeadCells,
  userTasksHeadCellsWithoutCustomer,
} from "./ChatHelper";
import { visuallyHidden } from "@mui/utils";
import { MoreVert } from "@material-ui/icons";
import { CreateUserTask } from "./UserTasks";
import { ChatStatusChip } from ".";
import { CheckCircle } from "../../Svgs";
import { Add } from "@mui/icons-material";
import { getUsersWithTasks } from "../../redux/actions/chatActions";

const TaskTable = ({ customer, openDeleteForm, user_from = "chat" }) => {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [rows, setRows] = useState([]);
  // hideing customer column inside customer
  const [showCustomerColumn, setShowCustomerColumn] = useState(true);

  const [formOpen, setFormOpen] = useState(false);
  const [editForm, setEditForm] = useState(false);
  const dispatch = useDispatch();
  const openForm = (edit) => {
    setEditForm(edit);
    setFormOpen(true);
  };
  const closeForm = () => setFormOpen(false);

  const allUserTasksFetched = useSelector(
    (state) => state.chats.allUserTasksFetched
  );
  const settingsUpUserTasks = useSelector(
    (state) => state.chats.settingsUpUserTasks
  );
  const users_with_tasks_fetched = useSelector(
    (state) => state.chats.users_with_tasks_fetched
  );
  const allTasks = useSelector((state) => state.chats.allTasks);
  const no_user_tasks = useSelector((state) => state.chats.no_user_tasks);

  useEffect(() => {
    setShowCustomerColumn(!isObjWithValues(customer));
  }, [customer]);

  useEffect(() => {
    if (!isArrayWithValues(allTasks) && !users_with_tasks_fetched) {
      dispatch(getUsersWithTasks());
    }

    return () => {};
  }, []);

  console.log(allTasks, "<<< all tasks");

  useEffect(() => {
    if (!isArrayWithValues(allTasks)) return;
    if (isObjWithValues(customer)) {
      setRows(
        allTasks
          .filter((i) => i.user_id == customer.id)
          ?.filter((i) =>
            user_from !== "chat" ? i.user_from === user_from : true
          )
      );
    } else setRows(allTasks);
  }, [allTasks, customer]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };
  console.log(rows);
  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  return (
    <Card sx={{ width: "100%", mt: 4, ...globalCardStyle }}>
      <CardContent>
        {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
        <Stack
          direction="row"
          alignItems={"center"}
          justifyContent="space-between"
        >
          <Stack
            direction="row"
            alignItems={"center"}
            spacing={2}
            sx={{ ml: 2 }}
          >
            {" "}
            <CheckCircle height={"25px"} width="25px" />
            <Typography
              sx={{ ...sectionLabel, padding: "0px", paddingLeft: "3px" }}
            >
              Tasks
            </Typography>
          </Stack>
          {/* {!isObjWithValues(customer) && (
            <Button startIcon={<Add />} variant="outlined" onClick={() => setFormOpen(true)}>
              Create Task
            </Button>
          )} */}
        </Stack>
        {(allUserTasksFetched &&
          !settingsUpUserTasks &&
          !isArrayWithValues(rows)) ||
        no_user_tasks ? (
          <NoTasks
            text="No tasks added yet"
            icon={
              <CheckCircle
                style={{ height: "70px", width: "70px", fill: "#c4c4c4" }}
                fillCircle="#c4c4c4"
              />
            }
          />
        ) : (
          <TableContainer>
            <Table
              aria-labelledby="tableTitle"
              size={dense ? "small" : "medium"}
            >
              <TableHead>
                <TableRow>
                  {/* <TableCell padding="checkbox">
                  <Checkbox
                    color="primary"
                    indeterminate={numSelected > 0 && numSelected < rowCount}
                    checked={rowCount > 0 && numSelected === rowCount}
                    onChange={onSelectAllClick}
                    inputProps={{
                      'aria-label': 'select all desserts',
                    }}
                  />
                </TableCell> */}
                  {(showCustomerColumn
                    ? userTasksHeadCells
                    : userTasksHeadCellsWithoutCustomer
                  ).map((headCell) => (
                    <TableCell
                      key={headCell.id}
                      align={headCell.numeric ? "right" : "left"}
                      padding={headCell.disablePadding ? "none" : "normal"}
                      sortDirection={orderBy === headCell.id ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === headCell.id}
                        direction={orderBy === headCell.id ? order : "asc"}
                        // onClick={createSortHandler(headCell.id)}
                      >
                        {headCell.label}
                        {orderBy === headCell.id ? (
                          <Box component="span" sx={visuallyHidden}>
                            {order === "desc"
                              ? "sorted descending"
                              : "sorted ascending"}
                          </Box>
                        ) : null}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {/* if you don't need to support IE11, you can replace the `stableSort` call with:
               rows.sort(getComparator(order, orderBy)).slice() */}
                {stableSort(
                  rows?.sort(
                    (a, b) => validateNumber(b?.date) - validateNumber(a?.date)
                  ),
                  getComparator(order, orderBy)
                )
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    let { platform } = row;
                    let lastMessage = "";
                    if (platform === "whatsapp") {
                      lastMessage = row?.message?.text?.body || "";
                    }
                    if (platform !== "whatsapp")
                      lastMessage = row?.message?.text || "";
                    return (
                      <Row
                        showCustomerColumn={showCustomerColumn}
                        row={row}
                        index={index}
                        openForm={openForm}
                        openDeleteForm={openDeleteForm}
                      />
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: (dense ? 33 : 53) * emptyRows,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        {rows.length > 5 ? (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        ) : null}
        <Dialog
          open={formOpen}
          keepMounted
          onClose={closeForm}
          aria-describedby="alert-dialog-slide-description"
          maxWidth="sm"
          fullWidth
          sx={{ ...dialogStyle }}
        >
          <CreateUserTask
            customer={customer}
            closeForm={closeForm}
            updateForm={editForm}

            // selectCustomer={}
          />
        </Dialog>
      </CardContent>{" "}
    </Card>
  );
};
export default TaskTable;

const Row = ({ showCustomerColumn, row, index, openForm, openDeleteForm }) => {
  const labelId = `enhanced-table-checkbox-${index}`;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    // event.stopPropagation()
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (e) => {
    // e.stopPropagation()
    setAnchorEl(null);
  };
  return (
    <TableRow
      hover
      onClick={() => {
        handleClose();
        openForm(row);
      }}
      // role="checkbox"
      sx={{ py: 2, cursor: "pointer" }}
      // aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.name}
      // selected={isItemSelected}
    >
      {/* <TableCell padding="checkbox">
      <Checkbox
        color="primary"
        checked={isItemSelected}
        inputProps={{
          "aria-labelledby": labelId,
        }}
      />
    </TableCell> */}
      {showCustomerColumn ? (
        <TableCell
          component="th"
          // id={labelId}
          scope="row"
          // padding="none"
        >
          <Stack direction={"row"} alignItems="center" spacing={3}>
            <Avatar
              src={row?.userDetails?.profile_pic}
              // onError={({ currentTarget }) => {
              //   currentTarget.onerror = null; // prevents looping
              //   currentTarget.src =
              //     "/static/img/default_avatar.webp";
              // }}
              // style={{
              //   height: "40px",
              //   width: "40px",
              //   borderRadius: "50%",
              // }}
            />
            <Typography sx={{ ...primaryLabel }}>
              {row.userDetails?.name}
            </Typography>
          </Stack>
        </TableCell>
      ) : null}
      <TableCell align="left">
        <Typography sx={{ ...primaryLabel }}>
          {formatServerValue(row.title)}
        </Typography>
      </TableCell>
      <TableCell align="right" style={{ whiteSpace: "nowrap" }}>
        <Typography sx={{ ...primaryLabel }}>
          {formatDate(new Date(row.date_created), "dd-mm-yyyy")}
        </Typography>
        <Typography sx={{ ...secondaryLabel }}>
          {formatDate(new Date(row.date_created), "hh:mm am/pm")}
        </Typography>
      </TableCell>
      <TableCell align="right">
        {reduceLargeText(row.description, 20)}
      </TableCell>
      <TableCell align="right">
        <Typography sx={{ ...primaryLabel }}>
          {row?.teamMemberInfo?.name}
        </Typography>
        {/* <Typography sx={{ ...secondaryLabel }}>
      Sales executive
    </Typography> */}
      </TableCell>
      <TableCell
        align="right"
        style={{
          whiteSpace: "nowrap",
          color: Date.now() < validateNumber(row.date) ? "green" : "red",
        }}
      >
        <Typography sx={{ ...primaryLabel }}>
          {formatDate(new Date(row.date), "dd-mm-yyyy")}
        </Typography>
        <Typography sx={{ ...secondaryLabel }}>
          {formatDate(new Date(row.date), "hh:mm am/pm")}
        </Typography>
      </TableCell>
      <TableCell align="right">
        <Typography sx={{ ...primaryLabel }}>
          <ChatStatusChip status={formatServerValue(row.status)} />
        </Typography>
      </TableCell>
      <TableCell align="right" onClick={(e) => e.stopPropagation()}>
        <IconButton onClick={handleClick}>
          <MoreVert />
        </IconButton>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              handleClose();
              openForm(row);
            }}
          >
            Edit
          </MenuItem>
          <MenuItem
            onClick={(e) => {
              // e.stopPropagation()
              handleClose();
              openDeleteForm(row);
            }}
          >
            Delete
          </MenuItem>
        </Menu>
      </TableCell>
    </TableRow>
  );
};
